<template>
  <div class="container">
    <div class="body1">
      <div class="title">美钥二维码案例展示</div>
        <div class="box1">
        <div class="case1">
          <div class="casepic1"></div>
          <div class="describe1">个人名片<span>，与众不同</span></div>
        </div>
        <div class="case2">
          <div class="casepic2"></div>
          <div class="describe2">产品宣传<span>，过目不忘</span></div>
        </div>
        <div class="case3">
          <div class="casepic3"></div>
          <div class="describe3">企业品牌<span>，别具一格</span></div>
        </div>
        <div class="case4">
          <div class="casepic4"></div>
          <div class="describe4">动态趣图<span>，妙趣横生</span></div>
        </div>
        </div>
    </div>
    <frontFooter></frontFooter>
  </div>
</template>

<script type="text/javascript">
import frontFooter from '@c/navigation/frontFooter.vue'
export default {
  name: 'cases',
  components: {
    frontFooter
  },
  mounted () {
    document.title = '美钥二维码 - 案例'
  }
}
</script>

<style scoped>
.body1 {
  background-color: rgb(255, 255, 255);
  font-size: 16px;
  color: white;
  background-image: url('../../assets/img/cases/back1.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center; 
  padding-bottom: 50px;
  height: 1000px;
  overflow: hidden;
}

.title {
  font-size: 40px;
  margin: 100px auto;
  text-align: center;
}
.describe1,
.describe2,
.describe3,
.describe4 {
  background: #37dba3;
  text-align: center;
}
.describe1:hover,
.describe2:hover,
.describe3:hover,
.describe4:hover {
  background: white;
  /* color: #37dba3; */
}
.box1 {
  width: 80%;
  margin-left: 10%;
  float: left;
}

.case1,
.case2,
.case3,
.case4 {
    /* float: left; */
  width: 20%;
  margin-left: 4%;
}
.case1,.case3 {
  float: left;
}
.case2,.case4 {
  float: left;
}
.casepic1,
.casepic2,
.casepic3,
.casepic4 {
  float: left;
  width: 100%;
  height: 410px;
}


.casepic1 {
  background-image: url('../../assets/img/cases/pic1.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}
.casepic2 {
  background-image: url('../../assets/img/cases/pic2.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}
.casepic3 {
  background-image: url('../../assets/img/cases/pic3.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}
.casepic4 {
  background-image: url('../../assets/img/cases/pic4.gif');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}


.describe1,
.describe2,
.describe3,
.describe4 {
  float: left;
  clear: both;
  width: 100%;
  margin-top: 0px;
  font-size: 20px;
  line-height: 120px;
  color: #fe816d;
  background: white;
}
@media (max-width:1915px) {
  .body1 {
    height: 800px;
  }
  .title {
    margin: 100px auto 0px;
  }

}
@media (max-width: 1024px) {
  .describe1 span,
  .describe2 span,
  .describe3 span,
  .describe4 span {
    display: none;
  }
}
@media (max-width: 420px) {
  body {
    height: 500px;
  }
  .title {
    font-size: 25px;
    /* margin-top: 20px; */
    margin: 40px 0px 0px 0px;
  }
  .describe1,
  .describe2,
  .describe3,
  .describe4 {
    height: 50px;
    line-height: 50px;
    font-size: 15px;
  }
  .describe1 span,
  .describe2 span,
  .describe3 span,
  .describe4 span {
    display: none;
  }
  .casepic1,
  .casepic2,
  .casepic3,
  .casepic4 {
    height: 150px;
  }
  .case1,
  .case2,
  .case3,
  .case4 {
    width: 40%;
  }
  .box1 {
    width: 80%;
    margin-left: 10%;
  }
  .case1,.case3 {
    float: left;
  }
  .case2,.case4 {
    float: right;
  }
  .body1 {
    height: auto;
  }
}
</style>

